<template>
 <v-card
    class="rounded-t-lg w-100 w-sm-auto mr-0 mr-sm-16"
    style="position: fixed; bottom: 0; right: 0px; z-index: 1000; transition: width 0.3s ease"
    :style="{ width: isExpanded ? '600px' : '300px' }"
    elevation="4"
    @click="offerExtended()"
    v-if="offerForm && offerForm[0]"
  >
     <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-title
          :class=" wasOfferExpanded && !isExpanded ? 'bg-background2 text-text' : 'bg-primary'"
          expand-icon="mdi-chevron-up"
          collapse-icon="mdi-chevron-down"
        >
        <h2>{{ offerForm[0]?.FormTitle }}</h2>
        </v-expansion-panel-title>
        
        <v-expansion-panel-text class="bg-background1">
          <v-card-text class="pa-4">
            <JSONForm :formData="offerForm[0]" :formType="FORM_TYPES.OFFER_FORM" :showTitle="false"/>
          </v-card-text>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels> 
  </v-card>
</template>
<script setup>
import JSONForm from "@/components/JSONForm/form.vue";
import usePageTypeStore from '@/composables/usePageTypeStore';
import { FORM_TYPES } from '@/constants/formTypes';
import { ref, computed } from 'vue';

const dataAll = useDataAll();
const { pageType } = usePageTypeStore();
const panel = ref(undefined); // undefined = closed, 0 = open

const isExpanded = computed(() => {
  return panel.value === 0;
});

 
const wasOfferExpanded = ref(false);
onMounted(() => {
  // only once per session primary color on button, when clicked grayed.
  wasOfferExpanded.value = !!sessionStorage.getItem('offerExpanded');
});
function offerExtended(){
  sessionStorage.setItem('offerExpanded',1)
  wasOfferExpanded.value = true;
}

const offerForm = dataAll.getKey("OfferForm", []);

</script>